import { useCallback, useRef, useState } from "react";
import { ShieldCheckIcon } from "lucide-react";
import { ActivitySection } from "./ActivitySection";
import { PasswordSection } from "./PasswordSection";
import { ReauthDialog } from "./ReauthDialog";
import { SessionsSection } from "./SessionsSection";

export const Security = () => {
  const [reauth, setReauth] = useState<{ reason: string } | null>(null);
  const retryRef = useRef<() => void>(() => {});

  const requireReauth = useCallback((retry: () => void, reason: string) => {
    retryRef.current = retry;
    setReauth({ reason });
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-3 px-1">
        <ShieldCheckIcon className="mt-0.5 size-5 shrink-0 text-emerald-400" />
        <div className="space-y-0.5">
          <h2 className="text-base font-semibold text-white">Security</h2>
          <p className="text-muted-foreground text-sm">
            Manage how you sign in and every device that has access to your
            account.
          </p>
        </div>
      </div>
      <PasswordSection />
      <SessionsSection onReauthRequired={requireReauth} />
      <ActivitySection />
      <ReauthDialog
        open={!!reauth}
        reason={reauth?.reason ?? ""}
        onOpenChange={open => !open && setReauth(null)}
        onConfirmed={() => retryRef.current()}
      />
    </div>
  );
};
